import { render, staticRenderFns } from "./ReviewInformation.vue?vue&type=template&id=f651bb00&scoped=true"
import script from "./ReviewInformation.vue?vue&type=script&lang=js"
export * from "./ReviewInformation.vue?vue&type=script&lang=js"
import style0 from "./ReviewInformation.vue?vue&type=style&index=0&id=f651bb00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f651bb00",
  null
  
)

export default component.exports